import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/parking_relief_codes',
  component: Management,
  redirect: '/parking_relief_codes/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/parking_relief_codes/List'),
      meta: {
        auth: Auth.listParkingReliefCodes
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/parking_relief_codes/New'),
      meta: {
        auth: Auth.createParkingReliefCode
      }
    }
  ]
}
